var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBookBookSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "gray",
    height: "15px",
    width: "15px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492.308 492.308",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M483.683,14.104c-77.81-9.724-159.79,4.885-237.529,42.096C168.418,18.988,86.412,4.409,8.625,14.104L0,15.181v422.731 l11.067-1.385c75.327-9.413,155.072,5.183,230.519,42.154l1.237,0.603l3.018,1.791l0.325-0.159l0.444,0.216l3.227-2.014 l0.811-0.399c75.519-37.019,155.236-51.587,230.591-42.192l11.067,1.385V15.181L483.683,14.104z M236.308,454.431 c-59.058-26.692-120.351-40.375-180.202-40.375c-12.207,0-24.361,0.567-36.413,1.712V32.671 c70.966-7.077,145.577,6.856,216.615,40.587V454.431z M472.615,415.767c-71.048-6.683-145.346,6.51-216.615,38.683V73.257 c71.038-33.731,145.611-47.683,216.615-40.587V415.767z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookBookSvgrepoCom);
export default __webpack_public_path__ + "static/media/open-book-book-svgrepo-com.3f37716e2fce38f07c628d6d94a96116.svg";
export { ForwardRef as ReactComponent };